import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { WithApp } from 'contexts/appContext';

// Import Components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//@material-ui/core

// @material-ui/icons
import { Cancel, CheckCircle, Dashboard, HourglassEmpty, Visibility } from '@material-ui/icons';

import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import { Link } from 'react-router-dom';
import { wsGetAll } from 'services/WService';
import { currency } from 'hooks/Pipe';
import Check from '@material-ui/icons/Check';
import moment from 'moment';
import { TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  ...styles,
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  cardIconTitle: {
    color: 'black',
    fontWeight: 'bold'
  },
  marginRight: {
    float: 'right',
    marginTop: '-30px'
  },
  marginTop: '15px'
}));

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'HR', accessor: 'id', width: 110 },
  { Header: 'Zona', accessor: 'zone', width: 90 },
  { Header: 'Estado', accessor: 'state', width: 120, align: 'center' },
  { Header: 'Inicio Jornada', accessor: 'hora_apertura', width: 130, align: 'center' },
  { Header: 'Primera.Liq.', accessor: 'primera_liquidacion', width: 120, align: 'center' },
  { Header: 'Jefe de reparto', accessor: 'boss' },
  { Header: 'N° Docs.', accessor: 'documents', width: 95, align: 'center' },
  { Header: 'Total', accessor: 'total', width: 100, align: 'center' },
  { Header: 'S/. atendidos', accessor: 'atendSoles', width: 130, align: 'right' },
  { Header: 'Avance', accessor: 'advance', width: 90, align: 'center' },
  { Header: 'Docs. ent.', accessor: 'entryDocs', width: 140, align: 'right' },
  { Header: 'S/. entregados', accessor: 'entrySoles', width: 130, align: 'right' },
  { Header: 'Anulados', accessor: 'anulatedDocs', width: 130, align: 'center' },
  { Header: 'S/. anulados', accessor: 'anulatedSoles', width: 120, align: 'right' },
  { Header: 'Docs. par.', accessor: 'partialDocs', width: 130, align: 'center' },
  { Header: 'S/. parciales', accessor: 'partialSoles', width: 120, align: 'right' },
  { Header: 'Pendientes', accessor: 'pendingDocs', width: 130, align: 'center' },
  { Header: 'S/. pendientes', accessor: 'pendingSoles', width: 140, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const listStates = [
  { id: 'N', name: 'Creado', color: 'warning', icon: <Check /> },
  { id: 'G', name: 'Generado', color: 'info', icon: <HourglassEmpty /> },
  { id: 'A', name: 'Anulado', color: 'danger', icon: <Cancel /> },
  { id: 'F', name: 'Facturado', color: 'warning', icon: <Check /> },
  { id: 'W', name: 'En Reparto', color: 'success', icon: <CheckCircle /> },
  {
    id: '1',
    name: 'Liq. de mercaderia',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '2',
    name: 'Liq. de mercaderia +',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '3',
    name: 'Liq. de documento',
    color: 'success',
    icon: <CheckCircle />
  },
  {
    id: '4',
    name: 'Liq. de documento +',
    color: 'success',
    icon: <CheckCircle />
  },
  { id: 'L', name: 'Liq. HR', color: 'success', icon: <CheckCircle /> },
  { id: '5', name: 'Cerrado', color: 'danger', icon: <Cancel /> }
];

export default WithApp(function DistributionTracking() {
  const classes = useStyles();

  const [listDT, setListDT] = useState([]);

  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));

  const [dataLoading, setDataLoading] = useState(false);
  async function getDocumentTracking() {
    setDataLoading(true);
    setListDT([]);
    let response = await wsGetAll(`deliv/sheet-distribution?created_at=${date}`);
    setDataLoading(false);
    if (response.success) {
      setListDT(response.data);
    }
  }

  useEffect(() => {
    getDocumentTracking();
  }, [date]);

  useEffect(() => { }, [listDT]);

  return (
    <div>
      <GridContainer>
        <GridItem sm={12} xs={12} xl={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <Dashboard />
              </CardIcon>

              <div>
                <h4 className={classes.cardIconTitle}>Avance de reparto {dataLoading && <LoadingSpinner />}</h4>
                <TextField
                  label="Fecha"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
            </CardHeader>
            <CardBody>
              <GridItem sm={12} xs={12} xl={12}>
                <ReactTable
                  excelName="Avance-de-reparto"
                  defaultWidth={2350}
                  columns={columns}
                  data={listDT.map((bDT, i) => ({
                    num: (
                      <div className="actions-left">
                        <AllowedGuard
                          permission={ConstantPermissions.DELIV_SHEET_DISTRIBUTIONS_SHOW}
                        >
                          <Link to={`${bDT.codprog}`}>
                            <Button justIcon round simple color="primary" className="like">
                              <Visibility />
                            </Button>
                          </Link>
                        </AllowedGuard>
                        {i + 1}
                      </div>
                    ),
                    id: bDT.codprog,
                    zone: bDT.base_zone_description || '-',
                    state:
                      listStates.findIndex((obj) => obj.id == bDT.estado) >= 0
                        ? listStates[listStates.findIndex((obj) => obj.id == bDT.estado)].name
                        : '-',
                    hora_apertura:
                      bDT.hora_apertura !== null ? moment(bDT.hora_apertura).format('LT') : '-',
                    primera_liquidacion:
                      bDT.primera_liquidacion !== null
                        ? moment(bDT.primera_liquidacion).format('LT')
                        : '-',
                    boss: bDT.manager_name || '-',
                    documents: bDT.total_orders || '-',
                    total: currency(bDT.total),
                    atendSoles: currency(bDT.progress_amount),
                    advance: parseFloat(bDT.progress_percentage || '0').toFixed(0) + '%',
                    entryDocs: parseFloat(bDT.entregados || '0').toFixed(0),
                    entrySoles: currency(bDT.soles_entregados),
                    anulatedDocs: parseFloat(bDT.anulados || '0').toFixed(0),
                    anulatedSoles: currency(bDT.soles_anulados),
                    partialDocs: parseFloat(bDT.docs_parciales || '0').toFixed(0),
                    partialSoles: currency(bDT.soles_parciales),
                    pendingDocs: parseFloat(bDT.pendientes || '0').toFixed(0),
                    pendingSoles: currency(bDT.soles_pendientes),
                    actions: '',
                  }))}
                />
              </GridItem>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
});
